import axios from "axios";

import { LMS_BASE_URL } from "../../../../utils/http/http-common";

import { LMS_TOKEN } from "../../../../utils/cookiesmanager";

import { getLMSData } from "../../../../utils/getLMSData";

export const getFeedbackQuestionsListApiCall = async ({
  course,
  languageId = 1,
  courseId,
}) => {
  const token = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.get(
      `${LMS_BASE_URL}/course/feedback-questions?type=${course}&languageId=${languageId}&courseId=${courseId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response?.data;
  } catch (error) {
    const { response } = error || {};

    if (response?.data?.statusCode === 401) {
      getLMSData();
    }
    throw error?.response?.data || error;
  }
};

export const saveInclusiveEducationFeedbackApiCall = async (args) => {
  const token = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.post(`${LMS_BASE_URL}/course/feedback`, args, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
